function setPilingGraphic(mars3d) {
  /**
   * 打桩对象
   *
   * @class AllPilingGraphic
   * @extends {mars3d.graphic.BasePointEntity}
   */
  class AllPilingGraphic extends mars3d.graphic.BasePointEntity {

    /**
     * 对象添加到图层前创建一些对象的钩子方法，
     * 只会调用一次
     * @return {void}  无
     * @private
     */
    _mountedHook() {
      this._models = []

      this.__models = []

      const point = this.point // 位置
      const floorHeight = this.style.spacing // 最小粒度,单位:米
      const floorCount = 12 // 定义一个最高层数
      const WorkStatus = this.attr.WorkStatus // 阶段，用来区分凿空还是振密
      const Depth = this.attr.Depth // 用来计算当前显示多少层
      this.depth = Depth

      let color = WorkStatus == 1 ? '#0000FF' : '#FF0000'
      this.style.color = color
      const floorNum = this.depthToFloor(Depth, floorHeight, floorCount)

      // 增加层
      for (let i = 0; i < floorCount; i++) {
        const alt = point.alt - i * floorHeight
        const model = new mars3d.graphic.ModelEntity({
          position: [point.lng, point.lat, alt],
          style: this.style,
          attr: {
            origAlt: alt // 记录原始高度
          }
        })
        model.show = i < floorNum ? true : false
        this._models.push(model)
      }
    }

    /**
     * 对象添加到图层上的创建钩子方法，
     * 每次add时都会调用
     * @return {void}  无
     * @private
     */
    _addedHook() {
      this._models.forEach((model) => {
        this._layer.addGraphic(model)
      })
    }

    /**
     * 对象从图层上移除的创建钩子方法，
     * 每次remove时都会调用
     * @return {void}  无
     * @private
     */
    _removedHook() {
      this._models.forEach((model) => {
        this._layer.removeGraphic(model)
      })
      this.__models.forEach((model) => {
        this._layer.removeGraphic(model)
      })
    }

    /**
     * 还原重置所有楼层
     * @return {void}  无
     */
    reset() {
      const point = this.point // 楼栋位置

      for (let i = 0; i < this._models.length; i++) {
        const model = this._models[i]

        model.show = false
        model.position = new mars3d.LatLngPoint(point.lng, point.lat, model.attr.origAlt)
      }
    }
    
    /**
     * 深度转换成层数
     * 
     * @param {Number} Depth 
     * @param {Number} floorHeight 
     * @param {Number} floorCount 
     */
    depthToFloor(Depth = 0, floorHeight = 3.5, floorCount = 12) {
      if (Depth <= 0) {
        return 0
      }
      let floorNum = Math.ceil(Depth / floorHeight)
      if (floorNum < 0) {
        return 0
      } else if (floorNum > floorCount) {
        return floorCount
      } else {
        return floorNum
      }
    }

    /**
     * 显示指定桩层
     *
     * @param {Number} depth 指定显示的深度
     * @param {Number} [time=1] 需要时间,单位:秒
     * @return {void}  无
     */
    showFloor(depth, workStatus, time = 1, floorHeight = 3.5) {
      const point = this.point // 位置

      let inter = 0

      const befor = this.depthToFloor(this.depth)
      const floorNum = this.depthToFloor(depth)
      const t = Math.ceil(time * 1000 / Math.abs(floorNum - befor))
      this.depth = depth

      // console.log(befor, floorNum, workStatus)

      if (workStatus === 1) {
        const color = workStatus == 1 ? '#0000FF' : '#FF0000'
        this._models.forEach(model => {
          model.setStyle({
            color: color
          })
        })

        for (let i = 0; i < befor; i++) {
          const alt = point.alt - i * floorHeight
          const m = new mars3d.graphic.ModelEntity({
            position: [point.lng, point.lat, alt],
            style: {
              url: './static/mapconfig/gltf/yuan.glb',
              fill: true,
              color: '#00FF00',
              hasShadows: false,
              opacity: 0.5,
              heading: 100
            }
          })
          this._layer.addGraphic(m)
          this.__models.push(m)
        }
        
      }

      if (floorNum === befor) {
        return
      }
      
      if (befor < floorNum) {
        let num = befor
        inter = setInterval(() => {
          
          try {
            const model = this._models[num]
            if (num === 0) {
              model.show = true
            } else {
              model.position = new mars3d.LatLngPoint(point.lng, point.lat, model.attr.origAlt + floorHeight)
              model.show = true
              model.moveTo({
                position: [point.lng, point.lat, model.attr.origAlt],
                time: t / 1000
              })
            }
            num++
            if (num > floorNum - 1) {
              clearInterval(inter)
              if (this.__models.length > 0 && num > this.__models.length) {
                for (let i = this.__models.length; i < num; i++) {
                  const alt = point.alt - i * floorHeight
                  const m = new mars3d.graphic.ModelEntity({
                    position: [point.lng, point.lat, alt],
                    style: {
                      url: './static/mapconfig/gltf/yuan.glb',
                      fill: true,
                      color: '#00FF00',
                      hasShadows: false,
                      opacity: 0.5,
                      heading: 100
                    }
                  })
                  this._layer.addGraphic(m)
                  this.__models.push(m)
                }
              }
            }
          } catch (error) {
            clearInterval(inter)
          }
        }, t)
      } else if (befor > floorNum) {
        let num = befor - 1
        inter = setInterval(() => {
          try {
            const model = this._models[num]
            if (num === 0) {
              model.show = false
            } else {
              model.moveTo({
                position: [point.lng, point.lat, model.attr.origAlt + floorHeight],
                time: t / 1000
              })
              setTimeout(() => {model.show = false}, t / 1000)
            }
            num--
            if (floorNum > num) {
              clearInterval(inter)
            }
          } catch (error) {
            clearInterval(inter)
          }
        }, t)
      }
      
    }

    /**
     * 清除打完的
     */
    clearStatus1() {
      if (this.__models.length > 0) {
        setTimeout(() => {
          this._models.forEach((model) => {
            this._layer.removeGraphic(model)
          })
        }, 500)
      }
    }

    /**
     * 显示指定桩层
     *
     * @param {Number} floorNum 指定显示的层，第1层开始
     * @param {Number} [time=1] 需要时间,单位:秒
     * @return {void}  无
     */
    showHole(floorNum, time = 1, floorHeight = 3.5, floorCount = 12) {
      floorNum--

      const point = this.point // 位置

      const model = this._models[floorNum]
      if (floorNum === floorCount - 1) {
        model.show = true
      } else {
        model.position = new mars3d.LatLngPoint(point.lng, point.lat, model.attr.origAlt + floorHeight)
        model.show = true
        model.moveTo({
          position: [point.lng, point.lat, model.attr.origAlt],
          time: time // 移动的时长(单位 秒)
        })
      }
    }

  }
  mars3d.graphic.AllPilingGraphic = AllPilingGraphic
}

export { setPilingGraphic }



//////////////////
// WEBPACK FOOTER
// ./static/util/allPiling.js
// module id = null
// module chunks = 